import React from 'react';
import { FormattedNumber } from 'react-intl';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { ramsAOptions, ramsCOptions, ramsEcOptions, ramsEnvOptions, ramsPOptions, ramsROptions, ramsSOptions } from '../../../utils/data/rams';
import * as htmlHelper from '../../../utils/htmlHelper';
import { DataPanel, PanelSection, PanelTable, TableBody, TableData, TableHead, TableHeader, TableHeadRow, TableRow } from '../../elements';
import { RamsItem } from '../Common/RamsItem';
import { IFailureMode } from '../Interfaces/IFailureMode';

interface IConditionReportFmecaMaintenanceProps extends ITranslateProps {
    failureMode: IFailureMode;
}

class ConditionReportFmecaMaintenanceComponent extends React.Component<IConditionReportFmecaMaintenanceProps, Record<string, unknown>> {
    constructor(props: IConditionReportFmecaMaintenanceProps) {
        super(props);
    }

    public override render() {
        return (
            <DataPanel>
                {this.props.failureMode.maintenanceRemarks && (
                    <div className="row mt10 mb10">
                        <div className="col-md-12">{htmlHelper.newLineToBreak(this.props.failureMode.maintenanceRemarks)}</div>
                    </div>
                )}
                {this.props.failureMode.maintenanceMeasures?.length && (
                    <div className="row p10 mr20">
                        <PanelTable>
                            <TableHead>
                                <TableHeadRow>
                                    <TableHeader>{this.props.t('maintenanceMeasure.maintenanceMeasure')}</TableHeader>
                                    <TableHeader>{this.props.t('common.cost')}</TableHeader>
                                    <TableHeader>{this.props.t('maintenanceMeasure.urgency')}</TableHeader>
                                    <TableHeader>{this.props.t('common.year')}</TableHeader>
                                </TableHeadRow>
                            </TableHead>
                            <TableBody>
                                {this.props.failureMode.maintenanceMeasures.map((maintenanceMeasure) => (
                                    <TableRow key={maintenanceMeasure.id}>
                                        <TableData>
                                            {maintenanceMeasure.description}
                                            <div>
                                                {maintenanceMeasure.maintenanceType && `${maintenanceMeasure.maintenanceType}.`}
                                                {maintenanceMeasure.workType && ` ${maintenanceMeasure.workType}.`}
                                            </div>
                                        </TableData>
                                        <TableData>
                                            {maintenanceMeasure.cost && (
                                                <FormattedNumber value={maintenanceMeasure.cost} style="currency" currency="EUR" />
                                            )}
                                        </TableData>
                                        <TableData>{maintenanceMeasure.urgency} </TableData>
                                        <TableData>
                                            {maintenanceMeasure.planYear}{' '}
                                            {maintenanceMeasure.finalPlanYear && <span>-{maintenanceMeasure.finalPlanYear}</span>}
                                        </TableData>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </PanelTable>
                    </div>
                )}
                <PanelSection>
                    <RamsItem topLetter="R" ramsScore={this.props.failureMode.maintenanceRamsR} ramsOptions={ramsROptions} header="Betrouwbaarheid" />
                    <RamsItem topLetter="A" ramsScore={this.props.failureMode.maintenanceRamsA} ramsOptions={ramsAOptions} header="Beschikbaarheid" />
                    <RamsItem topLetter="S" ramsScore={this.props.failureMode.maintenanceRamsS} ramsOptions={ramsSOptions} header="Veiligheid" />
                    <RamsItem
                        topLetter="C"
                        ramsScore={this.props.failureMode.maintenanceRamsC}
                        ramsOptions={ramsCOptions}
                        header="Verzorgingsniveau"
                    />
                    <RamsItem topLetter="E" ramsScore={this.props.failureMode.maintenanceRamsEc} ramsOptions={ramsEcOptions} header="Gevolgkosten" />
                    <RamsItem topLetter="E" ramsScore={this.props.failureMode.maintenanceRamsEnv} ramsOptions={ramsEnvOptions} header="Milieu" />
                    <RamsItem topLetter="P" ramsScore={this.props.failureMode.maintenanceRamsP} ramsOptions={ramsPOptions} header="Imago" />
                </PanelSection>
            </DataPanel>
        );
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ConditionReportFMECAMaintenance = translate()(ConditionReportFmecaMaintenanceComponent);
